<aero-input type="text"
            [id]="'usernameId'"
            [name]="'username'"
            [required]="true"
            [(ngModel)]="username"
            (change)="onValueChange($event)"
            label="{{ 'account_settings_students_username' | translate }}">
</aero-input>

<aero-input type="text"
            [id]="'codeId'"
            [name]="'code'"
            [required]="true"
            [(ngModel)]="studentCode"
            (change)="onValueChange($event)"
            label="{{ 'add_student_code' | translate }}">
</aero-input>
<p *ngIf="addStudentError" class="bulb-connect-student-error"
   >{{ 'account_settings_connect_student_error' | translate }}</p>
<p class="bulb-student-code-info">{{ 'add_student_info' | translate }}</p>

<p class="bulb-child-modal-p">{{ 'account_settings_when_student_added' | translate }}</p>
